import {
  createPortfolioClient,
  PortfolioClient,
} from '@personal-portfolio/api-client';
import { snapshotFetch } from './content-snapshot/snapshot-fetch';

// The ONLY place in the app that reads import.meta.env.
// Everything downstream gets configuration injected.
export const appConfig = {
  strapiUrl: (import.meta.env.VITE_STRAPI_URL as string | undefined) ?? '',
  strapiToken: import.meta.env.VITE_STRAPI_API_TOKEN as string | undefined,
  // Where content comes from. Defaults to the snapshot bundled by
  // `npm run cms:snapshot`, so the site runs with no CMS at all; 'cms' fetches
  // it live from strapiUrl instead.
  contentSource:
    import.meta.env.VITE_CONTENT_SOURCE === 'cms'
      ? ('cms' as const)
      : ('snapshot' as const),
  // Falls back to the package version injected at build time so the persisted
  // query cache is busted on every release even without VITE_APP_VERSION set.
  appVersion:
    (import.meta.env.VITE_APP_VERSION as string | undefined) ??
    __BUILD_VERSION__,
  isDev: import.meta.env.DEV,
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string | undefined,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as
      string | undefined,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as
      string | undefined,
    appId: import.meta.env.VITE_FIREBASE_APP_ID as string | undefined,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID as
      string | undefined,
  },
};

// The snapshot swaps only the transport: the same client parses and maps it.
// An empty baseUrl makes media URLs root-relative, so the snapshot's media is
// served from this app's own public/uploads/ rather than the CMS.
export const portfolioClient: PortfolioClient =
  appConfig.contentSource === 'cms'
    ? createPortfolioClient({
        baseUrl: appConfig.strapiUrl,
        token: appConfig.strapiToken,
      })
    : createPortfolioClient({ baseUrl: '', fetch: snapshotFetch });
